module.exports = __webpack_public_path__ + "img/ctrl-p-stub-up--.352ba365.svg";